import { Accordion, Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";

import EmotionCard from "./EmotionCard";
import { useReport } from "../ReportContext";

const EmotionDescription = ({ emotion }) => {
	const { reportContent: { acf: { emotions } } } = useReport();
	return (
		<Row className="emotion-description">
			<Col>
				<EmotionCard className="position-sticky sticky-top" emotion={emotion} horizontal />
				<Accordion
					className={`emotion-description plain emotion-${emotion.toLowerCase()}`}
					defaultActiveKey="0"
					flush
				>
					<Accordion.Item eventKey="0">
						<Accordion.Header>
							Information about your access to
							<div className="emotion-title">{emotion}</div>
						</Accordion.Header>
						<Accordion.Body dangerouslySetInnerHTML={{ __html: emotions[emotion.toLowerCase()]?.description }} />
					</Accordion.Item>
				</Accordion>
			</Col>
		</Row>
	);
}

EmotionDescription.propTypes = {
	emotion: PropTypes.string.isRequired
};

export default EmotionDescription;